Parent Dashboard for user <b>{{userProfile.userName}}</b>